import React, { Component } from 'react';
import { connect } from 'react-redux';
import { dispatch, IRootDispatch, IRootState, state } from '../../../../stores/rematch/root-store';
import ActionModal, { ActionModalFooter } from '../../../../common-components/modal/ActionModal';
import { TransportAttendanceType } from '../../../../utilities/enum-utils';
import { Paragraph } from '../../../../common-components/typography';
import { GhostButton, PrimaryButton } from '../../../../common-components/buttons';
import { notification } from 'antd';

interface IChargeTransportBookingCancellationFeeModalProps {
  isOpen: boolean;
  onClose: () => void;
  transportBooking: any;
  doChangeTransportBookingToCustomerCancelWithFee: typeof dispatch.groupBookingsStore.doChangeTransportBookingToCustomerCancelWithFee;
  selectedGroupBookingItem: typeof state.groupBookingsStore.selectedGroupBookingItem;
  attendanceType: TransportAttendanceType;
}

interface IChargeTransportBookingCancellationFeeModalState {
  step: number;
  title: string;
  canManuallyClose: boolean;
}

class ChargeTransportBookingCancellationFeeModal extends Component<
  IChargeTransportBookingCancellationFeeModalProps,
  IChargeTransportBookingCancellationFeeModalState
> {
  state = {
    step: 1,
    title: 'Charge cancellation fee',
    canManuallyClose: true,
  };

  onCloseModal = () => {
    const { onClose } = this.props;
    this.setState({ step: 1, canManuallyClose: true, title: 'Charge cancellation fee' }, onClose);
  };

  onSubmit = async () => {
    const { transportBooking, selectedGroupBookingItem, attendanceType } = this.props;
    try {
      this.setState({ canManuallyClose: false });
      await this.props.doChangeTransportBookingToCustomerCancelWithFee({
        bookingId: selectedGroupBookingItem.bookingId,
        transportBookingId: transportBooking.attendanceId,
        attendanceType,
      });
      this.setState({ step: 2, canManuallyClose: true, title: 'Cancellation fee applied' });
    } catch (e) {
      this.setState({ canManuallyClose: true });
      notification.error({ message: 'Oops, something went wrong, please try again.' });
    }
  };

  renderView = () => {
    const { transportBooking } = this.props;
    const { step } = this.state;
    if (step === 1) {
      return (
        <div className="anim-fade-in">
          <Paragraph>Are you sure you want to charge a cancellation fee for this booking?</Paragraph>
          <Paragraph>
            The total cancellation fee for this booking is: <b>${transportBooking.billingTotal}</b>
          </Paragraph>
          <Paragraph>This booking will have to be approved before it can be sent to payments.</Paragraph>
          <ActionModalFooter>
            <GhostButton className="mr-medium" size="large" onClick={this.onCloseModal}>
              Cancel
            </GhostButton>
            <PrimaryButton size="large" icon="check" onClick={this.onSubmit}>
              Charge cancellation fee
            </PrimaryButton>
          </ActionModalFooter>
        </div>
      );
    }

    if (step === 2) {
      return (
        <div className="anim-slide-right">
          <Paragraph>You have successfully selected to charge a cancellation fee for this booking.</Paragraph>

          <ActionModalFooter>
            <PrimaryButton size="large" onClick={this.onCloseModal}>
              Close
            </PrimaryButton>
          </ActionModalFooter>
        </div>
      );
    }
  };

  render() {
    let { isOpen } = this.props;
    const { title } = this.state;
    return (
      <ActionModal
        isOpen={isOpen}
        title={title}
        width="medium"
        onClose={this.onCloseModal}
        canCloseOutside={this.state.canManuallyClose}
        showCloseButton={this.state.canManuallyClose}
        verticalAlignment="highest"
      >
        <div>{this.renderView()}</div>
      </ActionModal>
    );
  }
}

const mapState = (state: IRootState) => ({
  selectedGroupBookingItem: state.groupBookingsStore.selectedGroupBookingItem,
});

const mapDispatch = (dispatch: IRootDispatch) => ({
  doChangeTransportBookingToCustomerCancelWithFee:
    dispatch.groupBookingsStore.doChangeTransportBookingToCustomerCancelWithFee,
});

export default connect(mapState, mapDispatch)(ChargeTransportBookingCancellationFeeModal);
